import { apiClient } from "../config";

async function removeManagerFromProgram(id: any, person_id: any) {
  const res = await apiClient.delete(`/admin/programs/${id}/manager/${person_id}`);
  return res.data;
}

export default removeManagerFromProgram;